import { InjectionToken } from "@angular/core";

export const PRODUCT_PRICE_INFLATION_CONFIG = new InjectionToken<string>("PRODUCT_PRICE_INFLATION_CONFIG");
